import { useCallback } from "react";
import { useTheme } from "../../theme/ThemeProvider";
import type { ThemeDirection } from "../../theme/themeReducer";

function useDirection() {
  const { direction, setDirection } = useTheme();

  const updateDirection = useCallback(
    (dir: ThemeDirection) => setDirection(dir),
    [setDirection],
  );

  return [direction, updateDirection];
}

export default useDirection;
